import { Component, OnInit, Input } from '@angular/core';
import { Search, ListItem, ParamsService, ListService, CrudService, enumToArray } from 'elbuild-ui-lib-core';
import { Provincia, Company, DocTemplateEntity } from 'toolbandi-ui-lib';
import { Router, ActivatedRoute } from '@angular/router';
import { ListFiltersComponent } from 'elbuild-ui-componentslib';

@Component({
	selector: 'app-doctemplate-list-filters',
	templateUrl: './doctemplate-list-filters.component.html',
	styleUrls: ['./doctemplate-list-filters.component.scss']
})
export class DoctemplateListFiltersComponent extends ListFiltersComponent implements OnInit {

	keyword: string;

	@Input()
	tenderid: number;

	docTemplateTypes = enumToArray(DocTemplateEntity);

	constructor(router: Router,
		_route: ActivatedRoute,
		paramsService: ParamsService,
		private listService: ListService,
		private companyService: CrudService<Company>) {
		super(router, _route, paramsService);



	}

	ngOnInit() {

		this.setParams();

	}

	readQueryParams(params: string) {
		super.readQueryParams(params);

	}

	resetSearch() {
		this.keyword = undefined;
		super.resetSearch();
		this.setParams()
	}

	search(keeppage?: boolean) {
		super.search(keeppage);
		this.setParams();
	}





	setParams() {
		if (this.tenderid) {
			this.searchparams.addSimpleFilter('tenderid', this.tenderid)
		}
		/*if (this.active) {
			this.searchparams.addSimpleFilter('status', CompanyStatus.ACTIVE);
		} else {
			this.searchparams.removeSimpleFilter('status');
		}*/

	}

}
